






























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { UserData, getTodoMsg } from '@/api/systemManage/user'
import { getUserManual } from '@/api/documents/documents'
import { fileServer } from '@/api/common/upload'

import { deepCopy } from '@/configs/functions'

const AppModule = namespace('app')
const UserModule = namespace('user')

@Component({
  components: {}
})
export default class AppHeader extends Vue {
  public name = 'AppHeader'
  public loading = false

  public $refs!: {
    // menuCtrl: MenuItems
  }
  @AppModule.Getter public device!: string
  @AppModule.Getter public logo!: string

  // public version: string = window.baseConfig.Version
  public siteName: string = window.baseConfig.SiteName
  public copyright: string = window.baseConfig.Copyright

  @AppModule.Action('ToggleSideBar')
  public actionToggleSideBar!: () => void

  @AppModule.Getter
  public sidebar!: { opened: boolean, withoutAnimation: boolean }

  public toggleSideBar() {
    this.actionToggleSideBar()
  }

  @UserModule.Getter('userInfo')
  public curUser!: UserData

  //是否开启全屏模式
  public openFullscreen: boolean = false
  public requestFullscreen() {
    if (this.openFullscreen) {
      this.exitFullscreen()
    }
    else {
      this.openFullscreen = true
      this.doFullscreen()
    }
  }
  public exitFullscreen() {
    this.openFullscreen = false
    this.doFullscreen()

  }
  public doFullscreen() {
    if (this.openFullscreen) {
      if (document.body.requestFullscreen) {
        document.body.requestFullscreen()
      }
    }
    else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
    //this.setFullscreenClass()
  }

  public setFullscreenClass() {
    var bodyClass = document.body.className
    var className = 'full-screen'
    if (bodyClass.indexOf('full-screen') > -1) {
      bodyClass = bodyClass.replace(className, '')
      this.openFullscreen = false
    }
    else {
      bodyClass += ' ' + className
      this.openFullscreen = true
    }
    document.body.className = bodyClass
  }

  public created() {
    //禁掉F11的全屏的默认事件,不会禁止F11的退出全屏
    //F11的开关，它不会调用fullscreenchange事件，没法监听
    window.addEventListener('keydown', (event: any) => {
      const e = event || window.event
      if (e && e.keyCode === 122) {
        e.preventDefault()
      }
    })
    //监听全屏事件，为body设置相应样式
    document.addEventListener('fullscreenchange', v => {
      // console.log('fullscreenchange', document.fullscreenElement)
      this.setFullscreenClass()
      if (this.openFullscreen && this.sidebar.opened) {
        //全屏时，隐藏左侧菜单
        this.toggleSideBar()
      }
    })

    this.fetchData()
  }
  public taskLoading: boolean = false
  public totalTask: number = 0
  public taskList: any[] = []
  //未读公文数
  public govDoc: any = {}
  public taskClick(e: any) {
    var url: string = '/UnitBuiltFireSafety'//:'/CruiseEvent'
    const taskType = e.TaskType
    if (taskType > 10 && taskType < 20) {
      url = '/CruiseEvent'
    }
    else if (taskType > 20 && taskType < 30) {
      url = '/UnitBuiltFireSafety'
    }
    else if (taskType > 30 && taskType < 40) {
      url = '/HeritageUnit'
    }
    else if (taskType > 40 && taskType < 50) {
      url = '/UnitSnapshot'
    }
    else if (taskType > 50 && taskType < 60) {
      url = '/GovDoc'
    }
    url += '?' + e.Query
    this.$router.push(url)
  }
  public fetchData() {
    this.getTasks(true)
    this.getUserManual()
  }
  public getTasks(showLoad: boolean) {
    if (showLoad) {
      this.taskLoading = true
    }
    getTodoMsg().then((response: { data: any }) => {
      var data = response.data
      if (data) {
        var list = data.items
        const govIndex = list.findIndex((v: any) => v.TaskType == 51)
        if (govIndex > -1) {
          this.govDoc = deepCopy(list[govIndex])
          list.splice(govIndex, 1)
        }
        this.taskList = list
        this.totalTask = data.totalRecord
      }
      if (showLoad) {
        this.taskLoading = false
      }
    })
  }
  public userManuals: any = []
  public getUserManual() {
    getUserManual().then(
      (response: { data: any }) => {
        this.userManuals = response.data
      }
    )
  }
  public getFileUrl(f: any) {
    return fileServer(f.Id, f.TempGuid, f.OriginalFileName)
  }

  public mounted() {
    // window.eventBus.$emit('refreshTodos')
    window.eventBus.$on("refreshTodos", () => {
      this.getTasks(false)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("refreshTodos")
  }

  @UserModule.Action('LogOut')
  public actionLogout!: () => Promise<{}>

  public unitGis() {
    this.$router.push({ path: '/UnitGis' })
  }
  // 查看个人信息
  public myProfile() {
    this.$router.push({ path: '/MyProfile' })
  }

  public logout() {
    this.$confirm('确定要退出系统吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.actionLogout().then(() => {
        //location.reload() // 为了重新实例化vue-router对象 避免bug
        this.$router.push({ path: '/login' })
      })
    }).catch(() => {
      // this.$message({
      //   type: 'info',
      //   message: '已取消删除'
      // })
    })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
